import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ConsentService, isAuthenticatedPath } from '../services/consent.service';

@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.scss'],
})
export class CookieConsentComponent {
  constructor(private consent: ConsentService, private router: Router) {}

  /**
   * Shows on every public page a shared link could drop a new visitor onto, and
   * only until they choose. Suppressed in the authenticated app, where users are
   * subscribers tracked via their checkout agreement. Route-based only.
   */
  get visible(): boolean {
    if (this.consent.status !== 'unset') {
      return false;
    }
    return !isAuthenticatedPath(this.router.url);
  }

  accept(): void {
    this.consent.accept();
  }

  decline(): void {
    this.consent.decline();
  }
}
